@if (auth.booting()) {
  <app-app-splash />
} @else {
  <router-outlet />
}
